// KitchenList.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { viewerDisabledProps, isAdmin } from "../utils/permissions";
const KitchenList = () => {
  const [searchField, setSearchField] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [kitchens, setKitchens] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const navigate = useNavigate();
  const userid = localStorage.getItem("user_id");

  // Reset-password modal state (admin only)
  const [showResetModal, setShowResetModal] = useState(false);
  const [resetKitchen, setResetKitchen] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [resetSaving, setResetSaving] = useState(false);

  const fetchKitchens = async (kitchen_name = "") => {
    try {
      let url = `https://ims-attendanceback.indevconsultancy.in/api/kitchen?kitchen_id=${userid}`;
      if (kitchen_name) {
        url += `&kitchen_name=${kitchen_name}`;
      }
      const response = await axios.get(url);
      console.log("Fetched kitchens:", response.data);
      setKitchens(response.data.kitchens || []);
    } catch (error) {
      console.error("Error:", error);
      setKitchens([]);
    }
  };

  useEffect(() => {
    fetchKitchens();
  }, []);
  const handleSearch = () => {
    fetchKitchens(searchField);

    console.log("Search:", searchField, searchTerm);
    // TODO: Implement actual search
  };
  const handleReset = () => {
    setSearchField("");
    setSearchTerm("");
    // TODO: Reset data
  };
  const handleDelete = (id) => {
    console.log("Delete id:", id);
    // TODO: Implement delete
  };

  const openResetModal = (kitchen) => {
    setResetKitchen(kitchen);
    setNewPassword("");
    setShowResetModal(true);
  };

  const handleResetSave = async () => {
    if (!newPassword) {
      alert("Please enter a password.");
      return;
    }
    try {
      setResetSaving(true);
      const response = await axios.post(
        "https://ims-attendanceback.indevconsultancy.in/api/reset-kitchen-password/",
        {
          kitchen_id: resetKitchen.kitchenid,
          new_password: newPassword,
          admin_user_id: userid,
        }
      );
      if (response.data.status) {
        alert(response.data.message || "Password reset successfully.");
        setShowResetModal(false);
        fetchKitchens(searchField); // refresh the list to show the new password
      } else {
        alert(response.data.message || "Could not reset password.");
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      const msg = error?.response?.data?.message || "Something went wrong while resetting the password.";
      alert(msg);
    } finally {
      setResetSaving(false);
    }
  };

  const changePage = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(kitchens.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = kitchens.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className="px-3 py-3" style={{ minHeight: "100%" }}>
      <div className="card">
        <div className="card-header bg-skyBlue text-white">
          <h5 className="mb-0">Kitchen List</h5>
        </div>
        <div className="card-body">
          {/* Search Bar */}
          <div className="row g-2 g-md-3 align-items-center mb-3">
            <div className="col-12 col-md-8">
              <input
                type="text"
                placeholder=" Kitchen Name"
                className="form-control"
                value={searchField}
                onChange={(e) => setSearchField(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-5 d-none">
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col-6 col-md-2">
              <button className="btn btn-primary w-100" onClick={handleSearch}>
                Search
              </button>
            </div>
            <div className="col-6 col-md-2">
              <button className="btn btn-secondary w-100" onClick={handleReset}>
                Reset
              </button>
            </div>
          </div>

          {/* Table */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="mb-0">
              Total Kitchens: <strong>{kitchens.length}</strong>
            </h6>
            <button
              className="btn btn-primary bg-skyBlue"
              onClick={() => navigate("/add-kitchen")}
              {...viewerDisabledProps()}
            >
              Add Kitchen
            </button>
          </div>

          <div className="table-responsive">
            <table className="table table-bordered table-striped text-center">
              <thead className="table-light">
                <tr>
                  <th>S.No</th>
                  <th>Kitchen Name</th>
                  <th>Address</th>
                  <th>User Name</th>
                  <th>Pasword</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length === 0 ? (
                  <tr>
                    <td colSpan="7">No kitchens found.</td>
                  </tr>
                ) : (
                  currentItems.map((kitchen, index) => (
                    <tr key={kitchen.id}>
                      <td>{indexOfFirstItem + index + 1}</td>
                      <td>{kitchen.kitchen_name}</td>
                      <td>{kitchen.kitchen_address}</td>
                      <td>{kitchen.username}</td>
                      <td>{kitchen.password}</td>
                      <td className="g-2">
                        <button
                          className="btn btn-sm btn-danger me-1"
                          onClick={() => handleDelete(kitchen.id)}
                          {...viewerDisabledProps()}
                        >
                          Delete
                        </button>
                        <button
                          className="btn btn-sm btn-primary me-1"
                          onClick={() => {
                            const today = new Date()
                              .toISOString()
                              .split("T")[0];
                            localStorage.setItem("kitchen_id", kitchen.id);
                            navigate(
                              `/employee-attendance/${today}/${kitchen.kitchenid}`
                            );
                          }}
                        >
                          View
                        </button>

                        <button
                          className="btn btn-sm btn-info text-white"
                          // onClick={() => handleDelete(kitchen.id)}
                          onClick={() => navigate(`/employeeList/${kitchen.kitchenid}`)}
                        >
                          View Employee
                        </button>
                        {isAdmin() && (
                          <button
                            className="btn btn-sm btn-warning ms-1"
                            onClick={() => openResetModal(kitchen)}
                            title="Reset Password (admin only)"
                          >
                            Reset Password
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            {/* Pagination */}
            <nav
              className="mt-3 d-flex justify-content-center"
              aria-label="Pagination"
            >
              <ul className="pagination">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => changePage(currentPage - 1)}
                  >
                    Previous
                  </button>
                </li>
                {[...Array(totalPages)].map((_, i) => (
                  <li
                    key={i}
                    className={`page-item ${currentPage === i + 1 ? "active" : ""
                      }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => changePage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}
                <li
                  className={`page-item ${currentPage === totalPages ? "disabled" : ""
                    }`}
                >
                  <button
                    className="page-link"
                    onClick={() => changePage(currentPage + 1)}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div className="card-footer text-muted text-center small">
          Technology Partner: Indev Consultancy ©2025
        </div>
      </div>
      {showResetModal && (
        <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Reset Password — {resetKitchen?.kitchen_name}
                </h5>
                <button
                  className="btn-close"
                  onClick={() => setShowResetModal(false)}
                  disabled={resetSaving}
                />
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label>Password</label>
                  <input
                    type="text"
                    className="form-control"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowResetModal(false)}
                  disabled={resetSaving}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-warning"
                  onClick={handleResetSave}
                  disabled={resetSaving}
                >
                  {resetSaving ? "Saving..." : "Reset Password"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default KitchenList;
